// import { Injectable } from '@angular/core';
// import { Http, RequestOptions, Headers } from '@angular/http';
// import { DataencryptionService } from './dataencryption.service';
// import { CookieService } from 'ngx-cookie-service';
// import * as CryptoJS from 'crypto-js';
// import { environment } from '../../environments/environment';

// @Injectable()
// export class BasicDetailsService {
//   headers: Headers;
//   options: RequestOptions;
//   decryptUID: any;
//   decryptToken: any;
//   UID: any;
//   Token: any;
//   storageArr: any[];
//   storageEl: any;
//   BaseUrl = "https://webapi.truevoter.in/api";
//   BaseUrl0 = environment.config.baseUrlDhananjoy;
//   BaseUrl1 = environment.config.baseUrlSuppotView
//   constructor(private http: Http, private cookieService: CookieService,
//     private _encData: DataencryptionService) {
//     this.decryptUID = this._encData.decryptUID(this.cookieService.get('uId'));
//     this.UID = this.decryptUID.toString(CryptoJS.enc.Utf8);

//     this.decryptToken = this._encData.decryptToken(this.cookieService.get('token'));
//     this.Token = this.decryptToken.toString(CryptoJS.enc.Utf8);
//   }

//   downloadBasicDetails(uid, epid) {
//     return this.http.get(this.BaseUrl + '/BasicDetails/downloadBasicDetails?uId=' + uid + '&epId=' + epid)
//       .map(res => res.json());
//   }
//   downloadDbcount() {
//     return this.http.get(this.BaseUrl + '/SupportDbDetails/downloadtotalDbCounts')
//       .map(res => res.json());
//   }

//   // downloadBasicDetails(uId: string, epId: number) {
//   //   return this.http.get(
//   //     `${this.BaseUrl}/BasicDetails/downloadBasicDetails?uId=${uId}&epId=${epId}`
//   //   ).map(res => res.json());
//   // }

//   // ✅ NEW: Download nomination IDs by mobile number
//   downloadNominationIdOnMobile(userMobile: string) {
//     console.log('Service: Fetching nomination IDs for mobile:', userMobile);
//     return this.http.get(
//       `${this.BaseUrl}/BasicDetails/downloadnominationidonmobile?usermobile=${userMobile}`
//     ).map(res => res.json());
//   }

//   // ✅ NEW: Check if nomination ID exists for this mobile
//   checkNominationExist(userMobile: string, nominationId: string) {
//     console.log('Service: Validating nomination ID:', nominationId, 'for mobile:', userMobile);
//     return this.http.get(
//       `${this.BaseUrl}/BasicDetails/checknominationexist?usermobile=${userMobile}&Nomination_Id=${nominationId}`
//     ).map(res => res.json());
//   }

//   // downloadDistrict(stateId: number) {
//   //   return this.http.get(this.BaseUrl + '/District/GetDistrictByStateId/' + stateId)
//   //     .map(res => res.json());
//   // }

//   // downloadTaluka(districtId: number) {
//   //   return this.http.get(this.BaseUrl + '/Taluka/GetTalukaByDistrictId/' + districtId)
//   //     .map(res => res.json());
//   // }

// }
import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { DataencryptionService } from './dataencryption.service';
import { CookieService } from 'ngx-cookie-service';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';

@Injectable()
export class BasicDetailsService {
  headers: Headers;
  options: RequestOptions;
  decryptUID: any;
  decryptToken: any;
  UID: any;
  Token: any;
  storageArr: any[];
  storageEl: any;
  BaseUrl = "https://webapi.truevoter.in/api";
  BaseUrl0 = environment.config.baseUrlDhananjoy;
  BaseUrl1 = environment.config.baseUrlSuppotView;

  constructor(
    private http: Http, 
    private cookieService: CookieService,
    private _encData: DataencryptionService
  ) {
    this.decryptUID = this._encData.decryptUID(this.cookieService.get('uId'));
    this.UID = this.decryptUID.toString(CryptoJS.enc.Utf8);
    this.decryptToken = this._encData.decryptToken(this.cookieService.get('token'));
    this.Token = this.decryptToken.toString(CryptoJS.enc.Utf8);
  }

  // Existing method
  downloadBasicDetails(uid, epid) {
    return this.http.get(this.BaseUrl + '/BasicDetails/downloadBasicDetails?uId=' + uid + '&epId=' + epid)
      .map(res => res.json());
  }

  downloadDbcount() {
    return this.http.get(this.BaseUrl + '/SupportDbDetails/downloadtotalDbCounts')
      .map(res => res.json());
  }

  // ✅ NEW: Download nomination IDs by mobile number
  downloadNominationIdOnMobile(userMobile: string) {
    console.log('Service: Fetching nomination IDs for mobile:', userMobile);
    return this.http.get(
      this.BaseUrl + '/BasicDetails/downloadnominationidonmobile?usermobile=' + userMobile
    ).map(res => res.json());
  }

  // ✅ NEW: Check if nomination ID exists for this mobile
  checkNominationExist(userMobile: string, nominationId: string) {
    console.log('Service: Validating nomination ID:', nominationId, 'for mobile:', userMobile);
    return this.http.get(
      this.BaseUrl + '/BasicDetails/checknominationexist?usermobile=' + userMobile + '&Nomination_Id=' + nominationId
    ).map(res => res.json());
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/basic-details.service.ts